module.exports = __webpack_public_path__ + "static/media/28 North South.022b62a1.jpg";